webpackJsonp([154164700811403],{

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(17));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("defs", null, _react.default.createElement("path", {
	  id: "a",
	  d: "M0 0h24v24H0z"
	})), _react.default.createElement("path", {
	  fillRule: "evenodd",
	  d: "M13 9.5h5v-2h-5v2zm0 7h5v-2h-5v2zm6 4.5H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2zM6 11h5V6H6v5zm1-4h3v3H7V7zM6 18h5v-5H6v5zm1-4h3v3H7v-3z",
	  clipRule: "evenodd"
	})), 'Ballot');
	
	exports.default = _default;

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(17));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z"
	}), _react.default.createElement("path", {
	  fill: "none",
	  d: "M0 0h24v24H0z"
	})), 'Bookmark');
	
	exports.default = _default;

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(17));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fill: "none",
	  d: "M0 0h24v24H0z"
	}), _react.default.createElement("path", {
	  d: "M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"
	})), 'Dashboard');
	
	exports.default = _default;

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(17));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fill: "none",
	  d: "M0 0h24v24H0z"
	}), _react.default.createElement("path", {
	  d: "M23 12l-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12zm-10 5h-2v-2h2v2zm0-4h-2V7h2v6z"
	})), 'NewReleases');
	
	exports.default = _default;

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(49);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(58);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(57);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(169);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(41);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        _convertProps$placeho = _convertProps.placeholderStyle,
	        placeholderStyle = _convertProps$placeho === undefined ? {} : _convertProps$placeho,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle, placeholderStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  placeholderStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 142:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var style = {
	  rotatingCardContainer: {
	    perspective: '800px',
	    '& $cardRotate $back': {
	      transform: 'rotateY(180deg)',
	      zIndex: '5',
	      textAlign: 'center',
	      width: '100%',
	      height: '100%'
	    },
	    '&:not($manualRotate):hover $cardRotate': {
	      transform: 'rotateY(180deg)'
	    },
	    '&$manualRotate$activateRotate $cardRotate': {
	      transform: 'rotateY(180deg)'
	    },
	    '& $cardRotate $front': {
	      zIndex: '2',
	      position: 'relative'
	    },
	    '& $cardRotate $front, & $cardRotate $back': {
	      backfaceVisibility: 'hidden',
	      boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2)',
	      position: 'absolute',
	      backgroundColor: '#fff',
	      borderRadius: '6px',
	      top: '0',
	      left: '0',
	      WebkitBoxPack: 'center',
	      MsFlexPack: 'center',
	      justifyContent: 'center',
	      MsFlexLinePack: 'center',
	      alignContent: 'center',
	      display: 'flex',
	      WebkitBoxOrient: 'vertical',
	      WebkitBoxDirection: 'normal',
	      flexDirection: 'column'
	    }
	  },
	  activateRotate: {},
	  manualRotate: {},
	  cardRotate: {
	    transition: 'all 0.8s cubic-bezier(0.34, 1.45, 0.7, 1)',
	    transformStyle: 'preserve-3d',
	    position: 'relative',
	    background: 'transparent'
	  },
	  front: {},
	  back: {},
	  wrapperBackground: {
	    backgroundPosition: '50%',
	    backgroundSize: 'cover',
	    textAlign: 'center',
	    '&:after': {
	      position: 'absolute',
	      zIndex: '1',
	      width: '100%',
	      height: '100%',
	      display: 'block',
	      left: '0',
	      top: '0',
	      content: "''",
	      backgroundColor: 'rgba(0, 0, 0, 0.56)',
	      borderRadius: '6px'
	    }
	  },
	  cardBodyRotate: {
	    WebkitBoxPack: 'center',
	    MsFlexPack: 'center',
	    justifyContent: 'center',
	    MsFlexLinePack: 'center',
	    alignContent: 'center',
	    display: 'flex',
	    WebkitBoxOrient: 'vertical',
	    WebkitBoxDirection: 'normal',
	    flexDirection: 'column'
	  },
	  wrapperPrimary: {
	    background: 'linear-gradient(60deg,#212457,#212343)',
	    '& h1 small': {
	      color: 'rgba(255, 255, 255, 0.8)'
	    },
	    color: '#FFFFFF'
	  },
	  wrapperInfo: {
	    background: 'linear-gradient(60deg,#26c6da,#0097a7)',
	    color: '#FFFFFF'
	  },
	  wrapperSuccess: {
	    background: 'linear-gradient(60deg,#66bb6a,#388e3c)',
	    color: '#FFFFFF'
	  },
	  wrapperWarning: {
	    background: 'linear-gradient(60deg,#ffa726,#f57c00)',
	    color: '#FFFFFF'
	  },
	  wrapperDanger: {
	    background: 'linear-gradient(60deg,#ef5350,#d32f2f)',
	    color: '#FFFFFF'
	  },
	  wrapperRose: {
	    background: 'linear-gradient(60deg,#ec407a,#c2185b)',
	    color: '#FFFFFF'
	  }
	};
	
	exports.default = style;
	module.exports = exports['default'];

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _materialKitProReact = __webpack_require__(15);
	
	var sectionInterestedStyle = {
	  title: _materialKitProReact.title,
	  cardTitle: _materialKitProReact.cardTitle,
	  coloredShadow: _materialKitProReact.coloredShadow,
	  textCenter: {
	    textAlign: 'center'
	  },
	  section: {
	    backgroundPosition: '50%',
	    backgroundSize: 'cover',
	    padding: '70px 0'
	  },
	  description: {
	    color: '#999'
	  }
	};
	
	exports.default = sectionInterestedStyle;
	module.exports = exports['default'];

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _materialKitProReact = __webpack_require__(15);
	
	var _imagesStyles = __webpack_require__(47);
	
	var _imagesStyles2 = _interopRequireDefault(_imagesStyles);
	
	var _rotatingCards = __webpack_require__(142);
	
	var _rotatingCards2 = _interopRequireDefault(_rotatingCards);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = _extends({
	  container: _materialKitProReact.container,
	  coloredShadow: _materialKitProReact.coloredShadow,
	  title: _materialKitProReact.title,
	  mlAuto: _materialKitProReact.mlAuto,
	  cardTitle: _materialKitProReact.cardTitle
	}, _imagesStyles2.default, _rotatingCards2.default, {
	  sectionGray: {
	    background: '#E5E5E5'
	  },
	  sectionWhite: {
	    background: '#FFFFFF'
	  },
	  cardTitleAbsolute: _extends({}, _materialKitProReact.cardTitle, {
	    position: 'absolute !important',
	    bottom: '15px !important',
	    left: '15px !important',
	    color: '#fff !important',
	    fontSize: '1.125rem !important',
	    textShadow: '0 2px 5px rgba(33, 33, 33, 0.5) !important'
	  }),
	  cardTitleWhite: {
	    '&, & a': _extends({}, _materialKitProReact.title, {
	      marginTop: '.625rem',
	      marginBottom: '0',
	      minHeight: 'auto',
	      color: '#fff !important'
	    })
	  },
	  cardCategory: {
	    marginTop: '10px',
	    '& svg': {
	      position: 'relative',
	      top: '8px'
	    }
	  },
	  cardCategorySocial: {
	    marginTop: '10px',
	    '& .fab,& .fas,& .far,& .fal,& .material-icons': {
	      fontSize: '22px',
	      position: 'relative',
	      marginTop: '-4px',
	      top: '2px',
	      marginRight: '5px'
	    },
	    '& svg': {
	      position: 'relative',
	      top: '5px'
	    }
	  },
	  cardCategorySocialWhite: {
	    marginTop: '10px',
	    color: 'rgba(255, 255, 255, 0.8)',
	    '& .fab,& .fas,& .far,& .fal,& .material-icons': {
	      fontSize: '22px',
	      position: 'relative',
	      marginTop: '-4px',
	      top: '2px',
	      marginRight: '5px'
	    },
	    '& svg': {
	      position: 'relative',
	      top: '5px'
	    }
	  },
	  cardCategoryWhite: {
	    marginTop: '10px',
	    color: 'rgba(255, 255, 255, 0.7)'
	  },
	  cardCategoryFullWhite: {
	    marginTop: '10px',
	    color: '#FFFFFF'
	  },
	  cardDescription: _extends({}, _materialKitProReact.description),
	  cardDescriptionWhite: {
	    color: 'rgba(255, 255, 255, 0.8)'
	  },
	  author: {
	    display: 'inline-flex',
	    '& a': {
	      color: '#3C4858'
	    }
	  },
	  authorWhite: {
	    display: 'inline-flex',
	    '& a': {
	      color: 'rgba(255, 255, 255, 0.8)'
	    }
	  },
	  avatar: {
	    width: '30px',
	    height: '30px',
	    overflow: 'hidden',
	    borderRadius: '50%',
	    marginRight: '5px'
	  },
	  statsWhite: {
	    color: 'rgba(255, 255, 255, 0.8)',
	    display: 'inline-flex',
	    '& .fab,& .fas,& .far,& .fal,& .material-icons': {
	      position: 'relative',
	      top: '3px',
	      marginRight: '3px',
	      marginLeft: '3px',
	      fontSize: '18px',
	      lineHeight: '18px'
	    },
	    '& svg': {
	      position: 'relative',
	      top: '3px',
	      marginRight: '3px',
	      marginLeft: '3px',
	      width: '18px',
	      height: '18px'
	    }
	  },
	  stats: {
	    color: '#999999',
	    display: 'flex',
	    '& .fab,& .fas,& .far,& .fal,& .material-icons': {
	      position: 'relative',
	      top: '3px',
	      marginRight: '3px',
	      marginLeft: '3px',
	      fontSize: '18px',
	      lineHeight: '18px'
	    },
	    '& svg': {
	      position: 'relative',
	      top: '3px',
	      marginRight: '3px',
	      marginLeft: '3px',
	      width: '18px',
	      height: '18px'
	    }
	  },
	  justifyContentCenter: {
	    WebkitBoxPack: 'center !important',
	    MsFlexPack: 'center !important',
	    justifyContent: 'center !important'
	  },
	  iconWrapper: {
	    color: 'rgba(255, 255, 255, 0.76)',
	    margin: '10px auto 0',
	    width: '130px',
	    height: '130px',
	    border: '1px solid #E5E5E5',
	    borderRadius: '50%',
	    lineHeight: '174px',
	    '& .fab,& .fas,& .far,& .fal,& .material-icons': {
	      fontSize: '55px',
	      lineHeight: '55px'
	    },
	    '& svg': {
	      width: '55px',
	      height: '55px'
	    }
	  },
	  iconWrapperColor: {
	    borderColor: 'rgba(255, 255, 255, 0.25)'
	  },
	  iconWhite: {
	    color: '#FFFFFF'
	  },
	  iconRose: {
	    color: _materialKitProReact.roseColor
	  },
	  iconInfo: {
	    color: _materialKitProReact.infoColor
	  },
	  marginTop30: {
	    marginTop: '30px'
	  },
	  textCenter: {
	    textAlign: 'center'
	  },
	  marginBottom20: {
	    marginBottom: '20px'
	  }
	});
	
	exports.default = styles;
	module.exports = exports['default'];

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _materialKitProReact = __webpack_require__(15);
	
	var blogsSection = {
	  container: _materialKitProReact.container,
	  title: _materialKitProReact.title,
	  coloredShadow: _materialKitProReact.coloredShadow,
	  cardTitle: _materialKitProReact.cardTitle,
	  mlAuto: _materialKitProReact.mlAuto,
	  mrAuto: _materialKitProReact.mrAuto,
	  description: _materialKitProReact.description,
	  blog: {
	    padding: '50px 0'
	  },
	  cardCategory: {
	    marginBottom: '0',
	    marginTop: '10px',
	    '& svg,& .fab,& .fas,& .far,& .fal,& .material-icons': {
	      position: 'relative',
	      top: '8px',
	      lineHeight: '0'
	    }
	  },
	  description1: _extends({}, _materialKitProReact.description, {
	    lineHeight: '1.313rem'
	  }),
	  author: {
	    textTransform: 'uppercase'
	  },
	  card: {
	    marginBottom: '80px'
	  },
	  card4: {
	    marginBottom: '60px',
	    textAlign: 'center'
	  }
	};
	
	exports.default = blogsSection;
	module.exports = exports['default'];

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  color: ', ';\n'], ['\n  color: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: grid;\n  justify-content: center;\n  grid-template-columns: repeat(auto-fit, ', ');\n  grid-gap: ', ';\n\n  @media screen and (max-width: 1440px) {\n    width: 100%;\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n\n  @media screen and (max-width: 1000px) {\n    width: 100%;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-flow: row;\n    padding: 0 ', ';\n  }\n\n  @media screen and (max-width: 500px) {\n    grid-template-columns: ', ';\n  }\n'], ['\n  display: grid;\n  justify-content: center;\n  grid-template-columns: repeat(auto-fit, ', ');\n  grid-gap: ', ';\n\n  @media screen and (max-width: 1440px) {\n    width: 100%;\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n\n  @media screen and (max-width: 1000px) {\n    width: 100%;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-flow: row;\n    padding: 0 ', ';\n  }\n\n  @media screen and (max-width: 500px) {\n    grid-template-columns: ', ';\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(26);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(20);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withStyles = __webpack_require__(4);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Card = __webpack_require__(39);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _CardBody = __webpack_require__(55);
	
	var _CardBody2 = _interopRequireDefault(_CardBody);
	
	var _CardHeader = __webpack_require__(56);
	
	var _CardHeader2 = _interopRequireDefault(_CardHeader);
	
	var _gatsbyImage = __webpack_require__(60);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _materialKitProReact = __webpack_require__(15);
	
	var _imagesStyles = __webpack_require__(47);
	
	var _imagesStyles2 = _interopRequireDefault(_imagesStyles);
	
	var _sectionCards = __webpack_require__(100);
	
	var _sectionCards2 = _interopRequireDefault(_sectionCards);
	
	var _materialKitProReact2 = __webpack_require__(15);
	
	var _sectionInterestedStyle = __webpack_require__(98);
	
	var _sectionInterestedStyle2 = _interopRequireDefault(_sectionInterestedStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var style = _extends({}, _imagesStyles2.default, _sectionCards2.default, _sectionInterestedStyle2.default, {
	  cardTitle: _materialKitProReact2.cardTitle
	});
	
	var PostListing = function (_React$Component) {
	  _inherits(PostListing, _React$Component);
	
	  function PostListing() {
	    _classCallCheck(this, PostListing);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PostListing.prototype.getPostList = function getPostList() {
	    var postList = [];
	    try {
	      this.props.postEdges.forEach(function (postEdge) {
	        postList.push({
	          path: postEdge.node.fields.slug,
	          category: postEdge.node.frontmatter.category,
	          cover: postEdge.node.frontmatter.cover.childImageSharp.resolutions,
	          title: postEdge.node.frontmatter.title,
	          date: postEdge.node.fields.date,
	          excerpt: postEdge.node.excerpt,
	          timeToRead: postEdge.node.timeToRead
	        });
	      });
	      return postList;
	    } catch (error) {
	      return 'Error: ' + error;
	    }
	  };
	
	  PostListing.prototype.getCategoryColor = function getCategoryColor(category) {
	    switch (category) {
	      case 'knowledge':
	        return _materialKitProReact.successColor;
	      case 'news':
	        return _materialKitProReact.dangerColor;
	      case 'blog':
	        return _materialKitProReact.warningColor;
	    }
	  };
	
	  PostListing.prototype.render = function render() {
	    var _this2 = this;
	
	    var classes = this.props.classes;
	
	    var postList = this.getPostList();
	    return _react2.default.createElement(
	      PostGrid,
	      null,
	      /* Your post list here. */
	      postList.map(function (post) {
	        return _react2.default.createElement(
	          _Card2.default,
	          { key: post.title, plain: true, blog: true },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: post.path },
	            _react2.default.createElement(
	              _CardHeader2.default,
	              { plain: true, image: true },
	              _react2.default.createElement(_gatsbyImage2.default, {
	                className: classes.imgFluid,
	                resolutions: post.cover,
	                alt: ''
	              }),
	              post.cover && _react2.default.createElement('div', {
	                className: classes.coloredShadow,
	                style: {
	                  backgroundImage: 'url(' + post.cover.base64 + ')',
	                  opacity: '1'
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _CardBody2.default,
	            { plain: true },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/categories/' + post.category + '/1' },
	              _react2.default.createElement(
	                PostCategory,
	                { color: _this2.getCategoryColor(post.category) },
	                post.category
	              )
	            ),
	            _react2.default.createElement(
	              'h4',
	              { className: classes.cardTitle },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/publication/' + post.path },
	                post.title
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: classes.description },
	              post.excerpt,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/publication/' + post.path },
	                ' Read More '
	              )
	            )
	          )
	        );
	      })
	    );
	  };
	
	  return PostListing;
	}(_react2.default.Component);
	
	var PostCategory = _styledComponents2.default.h6(_templateObject, function (p) {
	  return p.color;
	});
	
	var PostGrid = _styledComponents2.default.div(_templateObject2, function (p) {
	  return p.theme.col(4);
	}, function (p) {
	  return p.theme.col();
	}, function (p) {
	  return p.theme.col();
	}, function (p) {
	  return p.theme.col(22);
	});
	
	exports.default = (0, _withStyles2.default)(style)(PostListing);
	module.exports = exports['default'];

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.publicationsQuery = exports.PublicationsTitle = exports.PublicationsContainerInner = exports.PublicationsContainer = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding: ', ' ', ';\n  padding-top: 0;\n\n  @media screen and (max-width: 1440px) {\n    max-width: 100vw;\n    padding: 0 ', ' ', ';\n  }\n\n  @media screen and (max-width: 768px) {\n    padding: 0 ', ';\n    max-width: 100vw;\n    overflow: hidden;\n\n    .gatsby-image-wrapper {\n      width: 100% !important;\n    }\n  }\n'], ['\n  padding: ', ' ', ';\n  padding-top: 0;\n\n  @media screen and (max-width: 1440px) {\n    max-width: 100vw;\n    padding: 0 ', ' ', ';\n  }\n\n  @media screen and (max-width: 768px) {\n    padding: 0 ', ';\n    max-width: 100vw;\n    overflow: hidden;\n\n    .gatsby-image-wrapper {\n      width: 100% !important;\n    }\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  padding: 0 ', ';\n'], ['\n  padding: 0 ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  margin: 4rem 0;\n\n  @media screen and (max-width: 768px) {\n    margin: 100px ', ' 0;\n  }\n'], ['\n  margin: 4rem 0;\n\n  @media screen and (max-width: 768px) {\n    margin: 100px ', ' 0;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(20);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(26);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(60);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _LayoutContainer = __webpack_require__(65);
	
	var _LayoutContainer2 = _interopRequireDefault(_LayoutContainer);
	
	var _withStyles = __webpack_require__(4);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _GridContainer = __webpack_require__(48);
	
	var _GridContainer2 = _interopRequireDefault(_GridContainer);
	
	var _GridItem = __webpack_require__(40);
	
	var _GridItem2 = _interopRequireDefault(_GridItem);
	
	var _Card = __webpack_require__(39);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _CardHeader = __webpack_require__(56);
	
	var _CardHeader2 = _interopRequireDefault(_CardHeader);
	
	var _AnchorPills = __webpack_require__(145);
	
	var _AnchorPills2 = _interopRequireDefault(_AnchorPills);
	
	var _PostListing = __webpack_require__(146);
	
	var _PostListing2 = _interopRequireDefault(_PostListing);
	
	var _materialKitProReact = __webpack_require__(15);
	
	var _Ballot = __webpack_require__(163);
	
	var _Ballot2 = _interopRequireDefault(_Ballot);
	
	var _Dashboard = __webpack_require__(165);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _NewReleases = __webpack_require__(167);
	
	var _NewReleases2 = _interopRequireDefault(_NewReleases);
	
	var _Bookmark = __webpack_require__(164);
	
	var _Bookmark2 = _interopRequireDefault(_Bookmark);
	
	var _blogsStyle = __webpack_require__(208);
	
	var _blogsStyle2 = _interopRequireDefault(_blogsStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// @material-ui/core components
	
	// core components
	
	
	var Publications = function (_Component) {
	  _inherits(Publications, _Component);
	
	  function Publications() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Publications);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getTabs = function () {
	      var tabs = [{
	        tabButton: 'Recent',
	        tabIcon: function tabIcon() {
	          return _react2.default.createElement(_Dashboard2.default, null);
	        },
	        tabLink: '/publications'
	      }];
	
	      var categories = _this.props.data.allCategories.edges.map(function (edge) {
	        return edge.node.frontmatter.category;
	      });
	
	      if (categories.includes('knowledge')) {
	        tabs.push({
	          tabButton: 'Knowledge',
	          tabIcon: function tabIcon() {
	            return _react2.default.createElement(_Ballot2.default, null);
	          },
	          tabLink: '/categories/knowledge'
	        });
	      }
	      if (categories.includes('news')) {
	        tabs.push({
	          tabButton: 'News',
	          tabIcon: function tabIcon() {
	            return _react2.default.createElement(_NewReleases2.default, null);
	          },
	          tabLink: '/categories/news'
	        });
	      }
	      if (categories.includes('blog')) {
	        tabs.push({
	          tabButton: 'Blog',
	          tabIcon: function tabIcon() {
	            return _react2.default.createElement(_Bookmark2.default, null);
	          },
	          tabLink: '/categories/blog'
	        });
	      }
	      return tabs;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Publications.prototype.getPublicationContext = function getPublicationContext() {
	    var categories = ['#knowledge', '#news', '#blog'];
	    var showFeaturedPost = !categories.includes(this.props.location.hash);
	    return showFeaturedPost;
	  };
	
	  Publications.prototype.getCategoryColor = function getCategoryColor(category) {
	    switch (category) {
	      case 'knowledge':
	        return _materialKitProReact.successColor;
	      case 'news':
	        return _materialKitProReact.dangerColor;
	      case 'blog':
	        return _materialKitProReact.warningColor;
	    }
	  };
	
	  Publications.prototype.render = function render() {
	    var _props = this.props,
	        classes = _props.classes,
	        data = _props.data;
	
	    var featuredPost = data.allMarkdownRemark.edges[0].node;
	    var recentPosts = data.allMarkdownRemark.edges.slice(1);
	
	    return _react2.default.createElement(
	      _LayoutContainer2.default,
	      null,
	      _react2.default.createElement(
	        PublicationsContainer,
	        null,
	        _react2.default.createElement(
	          PublicationsTitle,
	          null,
	          'Publications'
	        ),
	        _react2.default.createElement(
	          PublicationsContainerInner,
	          null,
	          _react2.default.createElement(_AnchorPills2.default, { color: 'primary', active: 0, tabs: this.getTabs() }),
	          this.getPublicationContext() && _react2.default.createElement(
	            _Card2.default,
	            { plain: true, blog: true, className: classes.card },
	            _react2.default.createElement(
	              _GridContainer2.default,
	              { alignItems: 'center' },
	              _react2.default.createElement(
	                _GridItem2.default,
	                { xs: 12, sm: 5, md: 5 },
	                _react2.default.createElement(
	                  _CardHeader2.default,
	                  { image: true, plain: true },
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: featuredPost.fields.slug },
	                    _react2.default.createElement(_gatsbyImage2.default, {
	                      resolutions: featuredPost.frontmatter.cover.childImageSharp.resolutions,
	                      alt: '...'
	                    })
	                  ),
	                  _react2.default.createElement('div', {
	                    className: classes.coloredShadow,
	                    style: {
	                      backgroundImage: 'url(' + featuredPost.frontmatter.cover.childImageSharp.resolutions.base64 + ')',
	                      opacity: '1'
	                    }
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                _GridItem2.default,
	                { xs: 12, sm: 6, md: 6 },
	                _react2.default.createElement(
	                  'h6',
	                  {
	                    style: {
	                      color: this.getCategoryColor(featuredPost.frontmatter.category)
	                    },
	                    className: classes.cardCategory
	                  },
	                  featuredPost.frontmatter.category
	                ),
	                _react2.default.createElement(
	                  'h3',
	                  { className: classes.cardTitle },
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: featuredPost.fields.slug },
	                    featuredPost.frontmatter.title
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: classes.description1 },
	                  featuredPost.excerpt,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: featuredPost.fields.slug },
	                    ' Read More '
	                  )
	                ),
	                _react2.default.createElement(
	                  'small',
	                  { className: classes.author },
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    featuredPost.fields.parsedDate,
	                    ' \xA0\xA0\xA0',
	                    featuredPost.timeToRead,
	                    ' min read'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_PostListing2.default, { postEdges: recentPosts })
	        )
	      )
	    );
	  };
	
	  return Publications;
	}(_react.Component);
	
	Publications.defaultProps = {
	  active: 0,
	  color: 'primary'
	};
	
	var PublicationsContainer = exports.PublicationsContainer = _styledComponents2.default.div(_templateObject, function (p) {
	  return p.theme.col(1.5);
	}, function (p) {
	  return p.theme.col(4);
	}, function (p) {
	  return p.theme.col(2);
	}, function (p) {
	  return p.theme.col(1.5);
	}, function (p) {
	  return p.theme.col();
	});
	var PublicationsContainerInner = exports.PublicationsContainerInner = _styledComponents2.default.div(_templateObject2, function (p) {
	  return p.theme.col();
	});
	var PublicationsTitle = exports.PublicationsTitle = _styledComponents2.default.h2(_templateObject3, function (p) {
	  return p.theme.col();
	});
	
	var publicationsQuery = exports.publicationsQuery = '** extracted graphql fragment **';
	
	exports.default = (0, _withStyles2.default)(_blogsStyle2.default)(Publications);

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-publications-jsx-439b335e85c7aaea130f.js